(function () {
    "use strict";

    angular.module("app").factory("subContractorService", SubcontractorServiceFactory);

    SubcontractorServiceFactory.$inject = ["$filter"];
    function SubcontractorServiceFactory($filter) {
        return {
            CalculatePossibleEndDate: CalculatePossibleEndDate,
            GetLongestClearanceDate: GetLongestClearanceDate,
            GetValidateDatesErrorMessages: GetValidateDatesErrorMessages,
            IsValidCreateSubContractor: IsValidCreateSubContractor,
            IsValidChangeSubContractor: IsValidChangeSubContractor
        };

        function CalculatePossibleEndDate(fromDate, clearances) {
            if (!fromDate)
                return;

            const possibleEndDate = moment(fromDate).add(1, "y");

            if (!clearances)
                return possibleEndDate.toDate();

            const longestClearanceDate = moment(GetLongestClearanceDate(clearances));
            if (longestClearanceDate.isSameOrBefore(possibleEndDate))
                return longestClearanceDate.toDate();
            return possibleEndDate.toDate();
        }

        function GetLongestClearanceDate(clearances) {
            if (!clearances || clearances.length < 1 || !clearances[0])
                return null;

            const sorted = clearances.sort((a, b) => {
                const dateA = moment(a.DateValidTo);
                const dateB = moment(b.DateValidTo);
                return (dateA > dateB) ? -1 : (dateA < dateB) ? 1 : 0;
            });
            return sorted[0].DateValidTo;
        }

        function GetValidateDatesErrorMessages(subContractor, clearances) {
            const errorMessages = [];
            let longestClearanceDate;

            if (clearances) {
                longestClearanceDate = GetLongestClearanceDate(clearances);

                if (!longestClearanceDate) {
                    errorMessages.push($filter("habilTranslation")("Dossier_NoClearances"));
                    return errorMessages;
                }
            }

            if (moment(subContractor.ValidTo).diff(moment(subContractor.ValidFrom), "years", true) > 1)
                errorMessages.push($filter("habilTranslation")("SubContractors_DatesError_TimespanToLarge"));

            const clearanceValidTo = longestClearanceDate ? moment(longestClearanceDate) : moment(subContractor.ClearanceValidTo);

            if (moment(subContractor.ValidTo).isBefore(moment(subContractor.ValidFrom)))
                errorMessages.push($filter("habilTranslation")("SubContractors_DateError_DateFromIsBeforeDateTo"));

            if (clearanceValidTo < moment(subContractor.ValidTo))
                errorMessages.push($filter("habilTranslation")("SubContractors_DatesError_ValidToLargerThanClearanceDate"));

            if (!subContractor.ValidFrom || !subContractor.ValidTo)
                errorMessages.push($filter("habilTranslation")("SubContractor_FieldsNotFilledInError"));

            return errorMessages;
        }

        function IsValidCreateSubContractor(subContractor, clearances) {
            if (!subContractor || !clearances)
                return false;

            const invalidReferenceNbr = "A00000";

            const errorMessages = GetValidateDatesErrorMessages(subContractor, clearances);
            return subContractor &&
                subContractor.ValidFrom &&
                subContractor.ValidTo &&
                clearances.length > 0 &&
                clearances.some((c) => c.OrganisationNumber != invalidReferenceNbr) &&
                errorMessages.length === 0;
        }

        function IsValidChangeSubContractor(subContractor) {
            if (!subContractor)
                return false;
            const errorMessages = GetValidateDatesErrorMessages(subContractor, null);
            const isValid = subContractor &&
                subContractor.ValidFrom &&
                subContractor.ValidTo &&
                errorMessages.length === 0;
            return isValid;
        }
    }
})();
